export function getTopicCategarys() {
  return [
    {
      label: '测试题',
      value: 'TEST'
    },
    {
      label: '编程题',
      value: 'PROGRAM'
    },
    {
      label: '心理题',
      value: 'HEARTTOPIC'
    }
  ]
}

export function getDurations() {
  return [
    {
      label: '30',
      value: '30'
    },
    {
      label: '60',
      value: '60'
    },
    {
      label: '90',
      value: '90'
    },
    {
      label: '120',
      value: '120'
    },
    {
      label: '150',
      value: '150'
    }
  ]
}

export function getRoles() {
  return [
    {
      label: '全体人员',
      value: '全体人员'
    },
    {
      label: '前端人员',
      value: '前端人员'
    },
    {
      label: '后端人员',
      value: '后端人员'
    }
  ]
}

export function getRandomCreates() {
  return [
    {
      label: '是',
      value: 1
    },
    {
      label: '否',
      value: 0
    }
  ]
}
export function getReExam() {
  return [
    {
      label: '是',
      value: 1
    },
    {
      label: '否',
      value: 0
    }
  ]
}
export function getModes() {
  return [
    {
      label: '练习',
      value: 'PRACTICE'
    },
    {
      label: '考试',
      value: 'TEST'
    }
  ]
}
export function getStatus() {
  return [
    {
      label: '已发布',
      value: 'PUBLISHED'
    },
    {
      label: '未发布',
      value: 'UNPUBLISH'
    }
  ]
}
